export const state = () => ({
    selectClubManager: {},
    Result:'',
    editClubManager:{},
})
